import React from 'react';
import { FaSquare } from 'react-icons/fa';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H4, H5, UL, LI, P } from '../../../AbstractElements';
import { CurrentYear, LastYear, New, OurTotalProfitTitle, TotalProfit } from '../../../Constant';
import ApexCharts from 'react-apexcharts';
import { totalProfitOption } from '../../../Data/DashBoard/Ecommerce/ApexChart';

const OurTotalProfit = () => {
  return (
    <Col xxl='6' xl='5' md='6' className='box-col-30 xl-35'>
      <Card className='total-profit-chart'>
        <CardHeader className='card-no-border dflex justify-content-between'>
          <H5>{OurTotalProfitTitle}</H5>
          <div className='center-content'>
            <UL className='profit-list'>
              <LI className='d-flex align-items-center'>
                <FaSquare />
                <span>{LastYear}</span>
              </LI>
              <LI className='d-flex align-items-center'>
                <FaSquare />
                <span>{CurrentYear}</span>
              </LI>
            </UL>
          </div>
        </CardHeader>
        <CardBody className='p-0'>
          <div className='profit-goal'>
            <H4>
              $78,486.65 <span className='badge badge-primary ms-3'>{New}</span>
            </H4>
            <P>{TotalProfit}</P>
          </div>
          <ApexCharts options={totalProfitOption.options} series={totalProfitOption.series} height={300} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default OurTotalProfit;
